import React from "react";
import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h3>Ecunel Fitness Gym</h3>
          <p>
            Το κορυφαίο blog για fitness, υγεία και προπόνηση στην Ελλάδα.
            Ανακαλύψτε τα μυστικά της υγιεινής ζωής μαζί μας.
          </p>
          <p>
            <strong>Αριθμός Μητρώου:</strong> 49500140
          </p>
        </div>

        <div className="footer-section">
          <h3>Γρήγορες Συνδέσεις</h3>
          <ul>
            <li>
              <Link to="/">Αρχική</Link>
            </li>
            <li>
              <Link to="/about">Σχετικά με Εμάς</Link>
            </li>
            <li>
              <Link to="/contact">Επικοινωνία</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Επικοινωνία</h3>
          <ul>
            <li>
              <FaHome
                style={{
                  display: "inline",
                  marginRight: "8px",
                  color: "var(--electric-lime)",
                }}
              />
              Όδος Βασιλόπουλος, 61, 036 98, Καστοριά, Greece
            </li>
            <li>
              <FaPhone
                style={{
                  display: "inline",
                  marginRight: "8px",
                  color: "var(--electric-lime)",
                }}
              />
              +302467022500
            </li>
            <li>
              <FaEnvelope
                style={{
                  display: "inline",
                  marginRight: "8px",
                  color: "var(--electric-lime)",
                }}
              />
              <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a>
            </li>
            <li>
              <a href="https://wa.me/302467022500">WhatsApp</a>
            </li>
            <li>
              <a href="https://viber.me/302467022500">Viber</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {currentYear} Ecunel Fitness Gym. Όλα τα δικαιώματα
          διατηρούνται.
        </p>
        <div className="footer-links">
          <Link to="/privacy-policy">Πολιτική Απορρήτου</Link>
          <Link to="/terms-conditions">Όροι Χρήσης</Link>
          <Link to="/refund-policy">Πολιτική Επιστροφών</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
